__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2025-07-08-1751981735-beta-dev/";